import React from "react";
import "./style.css";
import Pic from "../../images/pic.png";
import { Fade } from "react-awesome-reveal";
function ComponentsSix() {
  return (
    <div className="container mainsign66">
      <Fade direction="up" triggerOnce="true">
        <div className="bgcolor6677">
          <div className="row">
            <div className=" col-lg-6 col-md-5 col-sm-12 d-flex justify-content-center align-items-center flex-column">
              <div>
                <div className="mblcircle6677">
                  <div className="circle6677 mb-5">
                    <p className="text-center  textone6677">3</p>
                  </div>
                </div>
                <h1 className="text-white text-start textsign6677 mb-5">
                  Share your details
                </h1>
                <p className="  text-white text-start textsign116677">
                  Once you share qr code for your any of
                  <br /> the profile, your friends can instantly
                  <br /> recieve your information.
                </p>
              </div>
            </div>
            <div className=" col-lg-6 col-md-7 col-sm-12 d-flex justify-content-center align-items-center flex-column">
              <img className="img-fluid imgimg6677" src={Pic} alt="" />
            </div>
          </div>
        </div>
      </Fade>
    </div>
  );
}

export default ComponentsSix;
